import { PageHero, Testimonials, CtaBand } from "@/components/site/sections";
import { Reveal, Overline } from "@/components/site/ui";
import { PORTFOLIO, IMAGES } from "@/data/content";

const spanFor = (size) =>
  size === "tall"
    ? "md:row-span-2"
    : size === "wide"
    ? "md:col-span-2"
    : "";

export default function Portfolio() {
  return (
    <>
      <PageHero
        overline="Portfolio"
        title="Homes we’ve designed, built and handed over."
        subtitle="A glimpse into the spaces we've transformed — each one designed around the people who live in it."
        image={IMAGES.interior3}
      />

      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[260px] gap-5">
          {PORTFOLIO.map((p, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className={spanFor(p.size)}>
              <div className="group relative h-full overflow-hidden rounded-2xl border border-black/10" data-testid={`portfolio-item-${i}`}>
                <img
                  src={p.image}
                  alt={p.title}
                  style={p.cropStyle}
                  className={`absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out ${p.cropStyle ? "" : "group-hover:scale-105"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 inset-x-0 p-6 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-[transform,opacity] duration-500">
                  <div className="text-white/60 text-xs tracking-[0.2em] uppercase">{p.tag}</div>
                  <h3 className="font-head text-white text-xl font-medium mt-1">{p.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Testimonials />
      <CtaBand />
    </>
  );
}
